export interface DprProgressWithoutTargetGridData {
  id: number | string;
  priority: number;
  progressWithoutTargetId: number;
  clearedTotal: number;
  clearedToday: number;
  comment: string;
  name: string;

  // used for internal grid computation
  clearedTotalInitialValue: number;
}
